import React from 'react';
import ReactAudioPlayer from 'react-audio-player';

import useScreenOrientation from './components/helpers/useScreenOrientation';
import backgroundLandscape from "./assets/background-landscape.webp";
import backgroundPortrait from "./assets/background-portrait.webp";
import Intro from "./components/Intro"
import MenuAppBar from "./components/MenuAppBar"
import SceneConfig from "./components/SceneConfig"
import PortraitOptions from "./components/PortraitOptions"

export default function App() {

  const isLandscape = useScreenOrientation();
  
  const [blurBackground, setBlurBackground] = React.useState(true);
  const [scenario, setScenario] = React.useState<any|null>(null);

  const [showIntro, setShowIntro] = React.useState(true);
  const [showTopBar, setShowTopbar] = React.useState(false);
  const [enableBGM, setEnableBGM] = React.useState(false);
  const [playBGM, setPlayBGM] = React.useState(false);
  const [showSceneConfig, setShowSceneConfig] = React.useState(false);
  const [showPortraitOptions, setShowPortraitOptions] = React.useState(false);

  //para poder regresar a los menus iniciales
  const [introViewVisible, setIntroViewVisible] = React.useState(true);
  const [videoViewVisible, setVideoViewVisible] = React.useState(false);
  const [productListViewVisible, setProductListViewVisible] = React.useState(false);

  const setLocalView = (view: string) => {
    let nextView = view
    if(nextView === "IntroSelection"){
      setProductListViewVisible(true)
      nextView = "Intro"
    }
    setShowTopbar(nextView !== "Intro")
    setShowIntro(nextView === "Intro")
    setShowSceneConfig(nextView === "SceneConfig")
    if(nextView === "Intro"){
      setBlurBackground(true)
    }
  };

  const setLocalScenario = (scenario: {}) => {
    setScenario(scenario);
    setLocalView("SceneConfig");
  };

  return (
    <div className="full-container-app">

      <div className="full-background-container active" style={{backgroundImage: `url(${isLandscape ? backgroundLandscape : backgroundPortrait})`}}>

        <div className={`full-background ${blurBackground ? "blur" : ""}`}>
          {showIntro && <Intro introViewVisible={introViewVisible} setIntroViewVisible={setIntroViewVisible} videoViewVisible={videoViewVisible} setVideoViewVisible={setVideoViewVisible}
                                productListViewVisible={productListViewVisible} setProductListViewVisible={setProductListViewVisible} setScenario={setLocalScenario}
                                setShowPortraitOptions={setShowPortraitOptions} playBGM={playBGM} setPlayBGM={setPlayBGM} setEnableBGM={setEnableBGM}/>}

          {showSceneConfig && <SceneConfig scenario={scenario} setScenario={setLocalScenario} setBlurBackground={setBlurBackground}/>}

          {showTopBar && <MenuAppBar isLogoVisible={true} isPositionAbsolute={true} isBackButtonVisble={true} isBlur={!blurBackground} playBGM={playBGM} setShowPortraitOptions={setShowPortraitOptions} setView={setLocalView} setPlayBGM={setPlayBGM}/>}
          
          {showPortraitOptions && <PortraitOptions setShowPortraitOptions={setShowPortraitOptions} />}

          {enableBGM && <ReactAudioPlayer src={require("./assets/sounds/looped.mp3")} autoPlay loop controls={false} muted={playBGM} id={"backgroundMusic"} volume={0.05} />}
        </div>
      </div>
    </div>
  );
}